export default {
  appName: '今日匯率',
  appDesc: '感謝您使用《今日匯率》提供的服務！',
  authorizationTableiOS01: 'iOS 14.5 以上允許應用程式追蹤',
  authorizationTableiOS02: '用於提供個人化廣告',
  authorizationTableAndroid01: '允許應用程式存取網際網路',
  authorizationTableAndroid02: '用於從伺服器取得匯率資料',
  authorizationTableAndroid03: '允許應用程式保持清醒',
  authorizationTableAndroid04: '用於防止應用休眠',
  authorizationTableAndroid05: '允許應用程式取得粗略位置資訊',
  authorizationTableAndroid06: '用於根據大致位置顯示當地貨幣匯率',
  companyName: '三河智士科技有限公司',
  contactEmail: "support{'@'}ifyyy.cn",
};
